export const COGNITIVE_CUSTOMER_TYPE = "cognitive";

// This is the field identifier used by the existing { uniqueId, value }
// patient payload. Keep it in one place so the API contract can be adjusted
// without changing the form components.
export const COGNITIVE_DIAGNOSIS_FIELD = "cognitive_diagnosis";
export const DIAGNOSIS_DATE_FIELD = "diagnosis_date";

export const COGNITIVE_DIAGNOSES = [
  "cognitively_normal",
  "amci",
  "mci_other_unspecified",
  "ad",
  "vd",
  "lbd",
  "ftd",
  "other_cognitive_diagnosis",
  "unknown_not_assessed",
];

export const BASE_MEDICATIONS = [
  "antiseizure",
  "diabetes",
  "pain_muscle",
  "mood_psych",
  "sedatives",
  "bp_heart",
];

export const COGNITIVE_ONLY_MEDICATIONS = [
  "sedating_allergy_cold",
  "bladder_oab",
  "parkinsons_anticholinergic",
  "steroids_recent_high_dose",
  "other_sleepiness_confusion",
];

export const COGNITIVE_MEDICATIONS = [
  ...BASE_MEDICATIONS,
  ...COGNITIVE_ONLY_MEDICATIONS,
];

export const getDefaultCognitiveBirthYear = (date = new Date()) =>
  date.getFullYear() - 50;
